<script>
import baseMixin from '@/mixins/baseMixin'
import dateMixin from '@/mixins/dateMixin'
import dayjs from '@/services/date'
import { DayOfWeek } from '@/shared/constants/date/DayOfWeek'
import { DayOfWeekIso } from '@/shared/constants/date/DayOfWeekIso'

export default {
  name: 'BookingSummaryEmptyDayBlock',
  mixins: [baseMixin, dateMixin],
  props: {
    selectedDate: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      day: null,
    }
  },
  computed: {
    icon() {
      // If passed cut off
      if (this.isToday && !this.hasAtLeastOneLocationNotPassedSameDayCutOff)
        return 'mdi-clock-alert-outline'

      if (this.isWeekend) return 'mdi-calendar-arrow-right'

      if (this.isPast) return 'mdi-calendar-blank-outline'

      return 'mdi-calendar-alert'
    },
    title() {
      if (this.isToday && !this.hasAtLeastOneLocationNotPassedSameDayCutOff)
        return this.$t('booking.emptyDayBlockTitlePassedCutOff')
      else if (this.isPast) return this.$t('booking.emptyDayBlockTitlePast')
      return this.$t('booking.emptyDayBlockTitleCurrent')
    },
    description() {
      if (this.isToday) {
        if (this.hasAtLeastOneLocationNotPassedSameDayCutOff)
          return this.$t('booking.emptyDayBlockDescToday')
        else return this.$t('booking.emptyDayBlockDescPassedCutOff')
      }
      if (this.isPast) return ''
      if (this.isWeekend) {
        return this.$t('booking.emptyDayBlockDescWeekend')
      }

      return this.$t('booking.emptyDayBlockDescDefault')
    },
    isWeekend() {
      return (
        this.day.day() === DayOfWeek.SATURDAY ||
        this.day.day() === DayOfWeek.SUNDAY
      )
    },
    isPast() {
      return this.day.isBefore(dayjs())
    },
    isToday() {
      // Tried to use diff() but was returning a difference of 0 for tomorrow. Very odd.
      return this.day.$d.toDateString() === dayjs().$d.toDateString()
    },
    compDateForCreateBooking() {
      let date = this.day
      if (this.isWeekend) {
        // Set the date to the following Monday from the selected date
        date = date.add(1, 'weeks').isoWeekday(DayOfWeekIso.MONDAY)
      } else if (
        this.isToday &&
        !this.hasAtLeastOneLocationNotPassedSameDayCutOff
      ) {
        // Create a booking for tomorrow if passed today's cutoff
        date = date.add(1, 'days')
      }

      return date.format('YYYY-MM-DD')
    },
  },
  created() {
    this.day = dayjs(this.selectedDate)
  },
  methods: {
    jumpToToday() {
      this.$emit('viewTodaysBookings')
    },
  },
}
</script>

<template>
  <v-card
    v-if="day"
    :class="[
      'transparent d-flex flex-column justify-center align-center text-center',
      isMobileViewPort ? '' : 'pa-8 mb-6',
    ]"
    elevation="0"
  >
    <v-card-title>
      <v-icon class="mb-5" style="font-size: 80px;"> {{ icon }} </v-icon>
    </v-card-title>
    <v-card-title>
      <h4 :class="[description ? 'mb-2' : '', 'font-weight-medium']">{{
        title
      }}</h4>
    </v-card-title>
    <v-card-text>
      <p class="ws-pre-wrap subtitle-1">{{ description }}</p>
    </v-card-text>
    <v-card-actions>
      <v-btn
        v-if="
          !isPast || (isToday && hasAtLeastOneLocationNotPassedSameDayCutOff)
        "
        id="booking-summary-empty-day-block_create-booking-btn"
        color="blue"
        large
        class="custom-elevation white--text px-4"
        :to="{
          name: 'bookings-create',
          query: { date: compDateForCreateBooking },
        }"
      >
        {{ this.$t('booking.createBtn') }}
      </v-btn>
      <v-btn
        v-else-if="!isToday"
        id="booking-summary-empty-day-block_jump-btn"
        color="blue"
        outlined
        large
        class="custom-elevation white--text px-4"
        @click="jumpToToday"
      >
        {{ this.$t('booking.emptDayBlockJumpToTodayBtn') }}
        <v-icon right>mdi-arrow-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
